import { ElementType } from 'react';
import { IconApproved, IconClock, IconSigned } from 'assets/img';
import { DocumentStatus } from '../documents-table.types';

const statuses = new Map<DocumentStatus, ElementType>([
  ['Pending', IconClock],
  ['Accepted', IconApproved],
  ['Signed', IconSigned],
]);

export const getDocumentStatusIcon = (status: DocumentStatus) => {
  return statuses.get(status) || IconClock;
};
